<template>
  <div class="quiz-response">
    <multiple-response-item :questionId="questionId" />

    <div class="cta">
      <vv-button @click="nextQuestion">{{ nextLabel }}</vv-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { VvButton } from '@/components/common'
import MultipleResponseItem from './MultipleResponseItem'

export default {
  name: 'MultipleResponse',
  components: { MultipleResponseItem, VvButton },
  computed: {
    ...mapGetters(['isLastQuizQuestion']),
    nextLabel() {
      return this.isLastQuizQuestion ? this.$t('quiz.lastQuestion') : this.$t('quiz.nextQuestion')
    },
    questionId() {
      return this.$store.state.route.params.questionId
    }
  },
  methods: {
    nextQuestion() {
      this.$emit('next')
    }
  }
}
</script>

<style lang="scss" scoped>
.response {
  margin-bottom: 30px;
}

.explanation {
  margin-bottom: 30px;
}
</style>
